<template>
  <section id="linkView" class="statv_container statv_page_bg">
	  <div class="statv_page_wrapper statv_wrapper">
		  <img class="poster" :src="isMobile ? link.img_link_mobile_url : link.img_link_url" :alt="link.title"/>
		  <div class="header">
			  <div class="info"><span> PROGRAM INFO </span> </div>
			  <div class="title"> <h1> {{link.title}} </h1> <span> {{link.sub_title}} </span> </div>
			</div>
		  <div class="body">
			  <p class="contents" v-html="link.contents"></p>
		  </div>
		  <div class="footer">
			  <div class="actor_title"> <em> 출연자 정보 </em> </div>
			  <div class="actor_list">
				  <figure class="actor_box" v-if="link.actor1_name !== ''">
					  <img class="actor_image" :src="link.img_actor1_url" :alt="link.actor1_name"/>
					  <p class="actor_name"> {{link.actor1_name}} </p>
				  </figure>
				  <figure class="actor_box" v-if="link.actor2_name !== ''">
					  <img class="actor_image" :src="link.img_actor2_url" :alt="link.actor2_name"/>
					  <p class="actor_name"> {{link.actor2_name}} </p>
				  </figure>
				  <figure class="actor_box" v-if="link.actor3_name !== ''">
					  <img class="actor_image" :src="link.img_actor3_url" :alt="link.actor3_name"/>
					  <p class="actor_name"> {{link.actor3_name}} </p>
				  </figure>
					<figure class="actor_box" v-if="link.actor4_name !== ''">
						<img class="actor_image" :src="link.img_actor4_url" :alt="link.actor4_name"/>
						<p class="actor_name"> {{link.actor4_name}} </p>
					</figure>
			  </div>
		  </div>
	  </div>
  </section>
</template>
<script>
import * as Store from "@/store/modules/link"
import Utils from "@/helpers/utils.js"
export default {
	data() {
		return {

		}
	},
	async created() {
		if(this.$route.query.link) {
			let target = this.$route.query.link
			await this.getLinks(target)
			this.setPage()
		}
	},
	computed: {
		...Store.mapState(['link']),
		isMobile() {
			return Utils.isMobile()
		}
	},
	methods: {
		...Store.mapActions(['getLinks']),
		setPage() {
			const nearestWithTitle = this.link.title + '｜SPOTV PLUS'
			const nearestWithMeta = [{
				name: 'description', 
				content: this.link.title +" "+ this.link.sub_title
			}]

			if(nearestWithTitle) document.title = nearestWithTitle;

			Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));

			if(nearestWithMeta) {
				// Turn the meta tag definitions into actual elements in the head.
				nearestWithMeta.map(tagDef => {
					const tag = document.createElement('meta');
					Object.keys(tagDef).forEach(key => {
						tag.setAttribute(key, tagDef[key]);
					});

					// We use this to track which meta tags we create, so we don't interfere with other ones.
					tag.setAttribute('data-vue-router-controlled', '');
					return tag;
				})
				// Add the meta tags to the document head.
				.forEach(tag => document.head.appendChild(tag));
			}
		}
	}
}
</script>
<style lang="less">
.statv_page_bg {
	min-height: 0 !important;
}
#linkView {
	.poster {
		display: block;
		width: 1080px;
		height: 370px;
	}
	.header {
		color: #ff6400;
		padding: 0 29px;
		padding-bottom: 8px;
		border-bottom: 2px solid #ff6400;
		transform: skew(-0.05deg);
		.info {
			font-family: "BebasNeue";
			font-size: 36px;
			margin-top: 50px;
			margin-bottom: 14px;
		}
		.title {
			display: block;
			> h1 {
				font-size: 44px;
				font-weight: 900;
				margin-right: 15px;
			}
			> span {
				font-size: 26px;
				font-weight: 900;
			}
		}
	}
	.body {
		margin-top: 20px;
		padding: 0 29px;
		.contents {
			font-size: 18px;
			font-weight: 400;
			color: #8F8F8F;
			text-align: left;
			letter-spacing: 1.5px;
			line-height: 34px;
			transform: skew(-0.05deg);
		}
	}
	.footer {
		margin-top: 100px;
		padding: 0 29px;
		.actor_title {
			font-size: 26px;
			font-weight: 900;
			color: #ff6400;
		}
		.actor_list {
			display: flex;
			flex-flow: row wrap;
			margin-top: 11px;
			.actor_box {
				display: flex;
				flex-flow: column wrap;
				align-items: center;
				margin-right: 30px;
				margin-bottom: 20px;
				width: 120px;
				.actor_image {
					display: block;
					width: 100%;
					height: 150px;
					margin-bottom: 10px;
				}
				.actor_name {
					font-size: 20px;
					font-weight: 900;
					color:#ff6400;
					transform: skew(-0.05deg);
				}
			}
		}
	}
}


.m #linkView { 
	.poster {
		display: block;
		width: 705px;
		height: 350px;
	}
	.header {
		padding: 0 15px;
		padding-bottom: 10px;
		.info {
			font-size: 50px;
			margin-top: 40px;
			margin-bottom: 20px;
		}
		.title {
			display: flex;
			flex-flow: column wrap;
			align-items: flex-start;
			> h1 {
				font-size: 44px;
				margin-bottom: 10px;
			}
			> span {
				font-size: 24px;
			}
		}
	}
	.body {
		margin-top: 17px;
		padding: 0 15px;
		.contents {
			font-size: 24px;
		}
	}
	.footer {
		margin-top: 100px !important;
		padding: 0 15px 160px;
		.actor_title {
			font-size: 24px;
			transform: skew(-0.05deg);
		}
		.actor_list {
			margin-top: 23px;
			.actor_box {
				flex-flow: column wrap;
				width: 196px;
				margin-right: 43px;
				&:nth-child(3n) {
					margin-right: 0px;
				}
				.actor_image {
					width: 100%;
					height: 245px;
				}
				.actor_name {
					font-size: 30px;
				}
			}
		}
	}
}
</style>
